module.exports = {
  search: 'Поиск',
  isCustomer: 'Клиент',
  isBookingAgent: 'Агент по бронированию',
  isOverseaAgent: 'Агент порта назначения',
  isDesignationAgent: 'Назначенный агент',
  isLocalAgent: 'Локальный агент',
  isSeaCmp: 'Судоходная компания',
  isAirCmp: 'Авиакомпания',
  isCustomsBroker: 'Таможенный брокер',
  isTruckCmp: 'Автоперевозчик',
  isWarehouse: 'Склад',
  isGlobal: 'Холдинговая компания',
  isShipper: 'Грузоотправитель',
  isConsignee: 'Грузополучатель',
  isNotify: 'Уведомляемая сторона',
  isActive: 'Действителен',
  isShowHq: 'Отображать ли клиента HQ',
  btMerge: 'Объединить',
  btnRemove: 'Удалить',
  btnAdd: 'Добавить',
  btnRefresh: 'Обновить',
  btnLookUp: 'Просмотреть',
  totalCount: 'Всего записей',
  btAudit: 'Проверить',
  btCacelAudit: 'Отменить проверку',
  approvedState: 'Статус проверки',
  approvedBy: 'Проверяющий',
  dateApproved: 'Дата проверки',
  dateCreated: 'Дата создания',
  to: 'До',
  dateModified: 'Дата изменения',
  parter: 'Партнер',
  customerType: 'Тип клиента',
  sales: 'Продажи',
  customerLevel: 'Уровень клиента',
  whetherReview: 'Проверен',
  whetherEffective: 'Действителен',
  amount: 'Количество записей',
  query: 'Запрос',
  add: 'Добавить',
  delete: 'Удалить',
  view: 'Просмотреть',
  review: 'Проверить',
  batchPrint: 'Массовая печать',
  B2BRegistrationInvitation: 'Приглашение на регистрацию B2B',
  freightAuthorization: 'Авторизация тарифов',
  combine: 'Объединить',
  batchEditInvoiceHeader: 'Массовое изменение реквизитов счета',
  batchEditSalers: 'Массовое изменение продаж',
  batchEditServer: 'Массовое изменение обслуживающего персонала',
  templateDownload: 'Скачать шаблон',
  import: 'Импорт',
  exportAgentList: 'Экспорт списка агентов',
  downloadImportTemplate: 'Скачать шаблон для импорта',
  downloadImportResults: 'Скачать результаты импорта',
  number: 'Номер',
  abbreviation: 'Сокращенное название',
  code: 'Код',
  chineseName: 'Название на китайском',
  englishName: 'Название на английском',
  branchCompany: 'Филиал',
  creator: 'Создатель',
  creationDate: 'Дата создания',
  modifier: 'Редактор',
  modificationDate: 'Дата изменения',
  ecommerceCustomer: 'Электронный коммерческий клиент',
  day30day: '30 дней (билеты)',
  day60day: '60 дней (билеты)',
  day90day: '90 дней (билеты)',
  gt90day: 'Более 90 дней (билеты)',
  all: 'Все',
  yes: 'Да',
  no: 'Нет',
  return: 'Назад',
  edit: 'Редактировать',
  save: 'Сохранить',
  cancel: 'Отмена',
  basicInformation: 'Основная информация',
  contacts: 'Контактное лицо',
  customer: 'Клиент',
  creditAccount: 'Кредитная задолженность',
  contractNumber: 'Номер договора',
  documentation: 'Документы',
  doorInformation: 'Информация о пункте',
  specialRequirements: 'Особые требования',
  invoicingRequirements: 'Требования к выставлению счетов',
  destinationPortHandlingAgent: 'Агент по обработке в порту назначения',
  destinationNominatedAgent: 'Уполномоченный агент по грузу в порту назначения',
  portLocation: 'Порт нахождения',
  spaceCarrier: 'Перевозчик квоты',
  spaceAgent: 'Агент квоты',
  warehouseInformation: 'Информация о складе',
  EDIConfiguration: 'Настройка EDI',
  AddressInformation: 'Адресная информация',
  BranchAuthorization: 'Авторизация филиала',
  activity: 'Активный',
  crossTenantAuthorize: 'Межарендное поручение',
  crossTenantAuthorizeAgreement: 'Соглашение о межарендном поручении',
  agree: 'Согласие',
  theOtherPlatformID: 'ID платформы контрагента',
  seaCmpAgent: 'Судовой агент',
  destinationAgent: 'Агент в порту назначения',
  nominatedAgent: 'Уполномоченный агент по грузу',
  localAgent: 'Локальный агент',
  settlementAgent: 'Расчетный агент',
  shippingCompany: 'Судоходная компания',
  airlineCompany: 'Авиакомпания',
  customsBroker: 'Таможенный брокер',
  warehouse: 'Склад',
  truckCompany: 'Автотранспортная компания',
  shipper: 'Грузоотправитель',
  consignee: 'Грузополучатель',
  notify: 'Уведомляющая сторона',
  chkMustInputScn: 'Обязательно ли заполнять отправителя/получателя/уведомляющего',
  others: 'Прочее',
  relatedBusinessType: 'Связанные виды деятельности',
  oceanExport: 'Морской экспорт',
  oceanImport: 'Морской импорт',
  airExport: 'Авиационный экспорт',
  airImport: 'Авиационный импорт',
  relatedBranch: 'Связанный филиал',
  paymentType: 'Тип оплаты',
  whetherCollection: 'Инкассо или нет',
  usingSettlementAgent: 'Использование расчетного агента',
  country: 'Страна (регион)',
  province: 'Провинция',
  city: 'Город',
  district: 'Район',
  address: 'Адрес',
  postCode: 'Почтовый индекс',
  telephone: 'Телефон',
  fax: 'Факс',
  website: 'Веб-сайт',
  rmbAccount: 'Счет в юанях',
  usdAccount: 'Счет в долларах',
  taxRate: 'Налоговая ставка',
  additionalDescription: 'Дополнительные примечания',
  tel: 'Телефон',
  sapCustomerCode: 'Код клиента SAP',
  sapSupplierCode: 'Код поставщика SAP',
  isSignContract: 'Подписание контракта или нет',
  ContractStatus: 'Статус подписания контракта',
  ClientContractStatus: 'Статус подписания контракта с клиентом',
  SupplierContractStatus: 'Статус подписания контракта с поставщиком',
  OverseasAgencyContractStatus: 'Статус подписания контракта с зарубежным агентом',
  OtherContractStatus: 'Статус подписания других контрактов',
  ContractApproxStatus: 'Статус номера контракта',
  name: 'Контактное лицо',
  function: 'Функция',
  isDefault: 'По умолчанию или нет',
  Email: 'Электронная почта',
  mobile: 'Мобильный телефон',
  pushNode: 'Толкающий узел',
  pushMode: 'Способ отправки уведомлений',
  remark: 'Примечание',
  airline: 'Маршрут',
  departmentBelonging: 'Подразделение',
  peers: 'Совместное перемещение',
  isPeers: 'Совместное перемещение (да/нет)',
  introductionDate: 'Дата активации i-trace',
  customerSpace1: 'Тип грузоперевозки',
  customerSpace2: 'Назначенный груз',
  customerSpace3: 'Самостоятельный сбор груза',
  portOfDestination: 'Порт назначения',
  theCorrespondingServicePartners: 'Ответственный сотрудник для партнера',
  theCorrespondingServiceOverseaAgent: 'Зарубежный клиент-менеджер агента в порту назначения',
  positionType: 'Тип должности',
  businessType: 'Тип операции',
  user: 'Пользователь',
  creditControlSettings: 'Настройки кредитного контроля',
  defaultCreditInfoSettings: 'Обслуживание кредитного контроля по умолчанию',
  defaultCreditInfoNote: 'Примечание: После настройки кредитного контроля по умолчанию, новые партнеры в системе будут автоматически использовать текущие настройки!',
  dateType: 'Тип даты',
  settlementMethod: 'Способ расчета',
  monthlySettlement: 'Ежемесячный расчет',
  blacklist: 'Черный список',
  accountPeriod: 'Период оплаты',
  limit: 'Лимит',
  settlementType: 'Тип расчета',
  settlementByBill: 'Оплата по счету',
  settlementNotByBill: 'Безналичный расчет',
  revenueAndExpenditureType: 'Тип дохода/расхода',
  collections: 'Поступление',
  payment: 'Платеж',
  depositAmount: 'Сумма депозита',
  revenueAndExpenditureDate: 'Дата оплаты/поступления',
  revenueAndExpenditureMethod: 'Способ оплаты/поступления',
  cash: 'Наличные',
  depositCurrency: 'Валюта депозита',
  day: 'День',
  week: 'Неделя',
  month: 'Месяц',
  space1: 'Дата операции',
  space2: 'Дата счета',
  space3: 'Расчет по неделям',
  space4: 'Ежемесячно в указанную дату',
  space5: 'Полумесячный расчет',
  space6: 'Чек',
  space7: 'Банковский перевод',
  space8: 'Простой вексель',
  space9: 'Инкассо/платеж по поручению',
  space10: 'Банковский кредит',
  effectiveDate: 'Дата вступления в силу',
  expiryDate: 'Дата окончания срока действия',
  fileNumber: 'Номер документа',
  remarks: 'Примечание',
  documentSize: 'Количество вложений',
  attachment: 'Приложение',
  uploadFile: 'Загрузить файл',
  upload: 'Загрузить',
  download: 'Скачать',
  fileName: 'Имя файла',
  fileType: 'Тип файла',
  fileFormat: 'Формат файла',
  fileSize: 'Размер файла',
  viewFile: 'Просмотреть файл',
  whetherUploadContractAttachment: 'Загрузить приложение к договору?',
  doorName: 'Название пункта',
  contact: 'Контактное лицо',
  doorAddress: 'Адрес пункта',
  canOverPrice: 'Возможна ли высокая ставка?',
  invoicingMethod: 'Способ выставления счета',
  invoicingPerBill: 'Выставление счета за одну накладную',
  invoicingPerMonth: 'Выставление счета по итогам месяца',
  invoicingNote: 'Примечание к счету',
  invoiceHeader: 'Наименование в счете',
  registrationNumber: 'ИНН',
  invoiceAddress: 'Адрес для счетов',
  bankOfInvoiceHeader: 'Банк для выставления счета',
  operation: 'Действие',
  bankMaintenance: 'Обслуживание банка',
  confirm: 'Подтвердить',
  currency: 'Валюта',
  bankName: 'Название банка',
  bankAccount: 'Банковский счет',
  swiftCode: 'SWIFT-код',
  paymentLine: 'Корреспондентский счет',
  forecastReceivingEmail: 'Email для получения прогнозов',
  oceanBillOfLadingAddress: 'Адрес для морских коносаментов',
  airBillOfLadingAddress: 'Адрес для авианакладных',
  agentLevel: 'Уровень агента',
  networkManager: 'Ответственный за сеть',
  billingAddress: 'Адрес для счетов',
  network: 'Сеть',
  portName: 'Название порта',
  carrier: 'Перевозчик',
  carrierType: 'Тип перевозчика',
  bookingMethod: 'Способ бронирования',
  choose: '-Выберите-',
  bookingAgent: 'Агент по бронированию',
  ediSenderCode: 'Код отправителя EDI',
  ediReceiverCode: 'Код получателя EDI',
  bookingPartyCode: 'Код бронирующего',
  loadFailed: 'Ошибка загрузки',
  deleteing: 'Удаление...',
  deleted: 'Удалено',
  occurredError: 'Ошибка возникла',
  deleteConfirmTitle: 'Подтверждение удаления',
  deleteConfirmMessage: 'Вы уверены, что хотите удалить эти данные?',
  formatInformation: 'Форматированная информация',
  notFormatInformation: 'Неформатированная информация',
  formatSynchronize: 'Синхронизация форматированной информации с неформатированной',
  codeAbbreviation: 'Аббревиатура кода',
  enterpriseCode: 'Код предприятия',
  partnerName: 'Название',
  detailAddress: 'Подробный адрес',
  phone: 'Номер телефона',
  email: 'Адрес EMAIL',
  relexNumber: 'Номер телекса',
  cityName: 'Название города',
  provinceCode: 'Код провинции',
  provinceName: 'Название провинции',
  postalCode: 'Почтовый индекс',
  countryCode: 'Код страны',
  aeoEnterpriseCode: 'Код предприятия AEO',
  specificContactName: 'Имя конкретного контакта',
  specificContactPhone: 'Номер телефона конкретного контакта',
  specificContactAddress: 'Адрес EMAIL конкретного контакта',
  specificContactRelexNumber: 'Номер телекса конкретного контакта',
  WarehouseType: 'Тип склада',
  WarehouseName: 'Название склада',
  WarehouseAddress: 'Адрес склада',
  WarehouseMap: 'Карта склада',
  PleaseSelect: 'Пожалуйста, выберите',
  Number: 'Количество билетов',
  GreaterThan: 'Больше',
  LessThan: 'Меньше',
  EqualTo: 'Равно',
  WhetherToPushSOPStatus: 'Отправлять статус SOP?',
  Push: 'Отправить',
  NoPushing: 'Не отправлять',
  portAgent: 'Портовый агент',
  forwardingAgent: 'Агент по отправке',
  loadingPlaceCompany: 'Компания места погрузки',
  signBillPlaceCompany: 'Компания места подписания',
  dischargePortCompany: 'Компания порта разгрузки',
  destinationPortCompany: 'Компания порта назначения',
  ParentCompany: 'Материнская компания',
  SelectFile: 'Выбрать файл',
  DeleteFile: 'Удалить файл',
  Confirm: 'Подтвердить',
  Cancel: 'Отмена',
  FileName: 'Имя файла',
  FileType: 'Тип файла',
  FileSize: 'Размер файла',
  Uploader: 'Загрузивший',
  UploadTime: 'Время загрузки',
  UploadProgress: 'Прогресс загрузки',
  DocumentType: 'Категория документа',
  UnselectedContact: 'Контакт не выбран',
  PartnerNotSaved: 'Партнер не сохранен',
  UpdateMaterial: 'Загрузить материалы',
  DataNotSelected: 'Данные не выбраны',
  RailwayExport: 'Желдор. эксп.',
  RefuseRemark: 'Причина отказа',
  Refuser: 'Отклонивший',
  RefuseDate: 'Дата отказа',
  REMARKS: 'Дополнительное пояснение',
  InternalRemark: 'Примечание к внутреннему оборудованию',
  supplyChainLines: 'Цепочка поставок',
  Middleman: 'Посредник',
  Factory: 'Завод',
  CompanyName: 'Название компании',
  Company: 'Компания',
  contacts_name: 'Контактное лицо',
  contacts_function: 'Должность',
  contacts_telephone: 'Телефон',
  contacts_email: 'Электронная почта',
  contacts_mobile: 'Мобильный телефон',
  contacts_remark: 'Примечание',
  credit_creditControlSettings: 'Настройки кредитного контроля',
  credit_dateType: 'Тип даты',
  credit_creditControlSettings_date: 'Тип даты настройки кредитного контроля',
  credit_creditControl_date: 'Тип даты кредитного контроля',
  credit_settlementMethod: 'Способ расчета',
  credit_monthlySettlement: 'Ежемесячный расчет',
  credit_blacklist: 'Черный список',
  credit_accountPeriod: 'Срок платежа',
  credit_limit: 'Лимит',
  credit_settlementType: 'Тип расчета',
  credit_settlementByBill: 'Расчет по счету',
  credit_settlementNotByBill: 'Бессчетный расчет',
  credit_revenueAndExpenditureType: 'Тип доходов и расходов',
  credit_collections: 'Поступление',
  credit_payment: 'Платеж',
  credit_depositAmount: 'Сумма залога',
  credit_revenueAndExpenditureDate: 'Дата поступления/платежа',
  credit_revenueAndExpenditureMethod: 'Способ поступления/платежа',
  credit_cash: 'Наличные',
  credit_depositCurrency: 'Валюта залога',
  credit_additionalDescription: 'Дополнительное пояснение',
  credit_day: 'День',
  credit_week: 'Неделя',
  credit_month: 'Месяц',
  credit_space1: 'Дата операции',
  credit_space2: 'Дата счёта-фактуры',
  credit_space3: 'Расчёт по неделям',
  credit_space4: 'Указанная дата каждого месяца',
  credit_space5: 'Полугодовой расчёт',
  credit_space6: 'Чек',
  credit_space7: 'Банковский перевод',
  credit_space8: 'Простой вексель',
  credit_space9: 'Инкассо и платёж',
  credit_space10: 'Банковский кредит',
  credit_wtCreateCompany: 'Добавить сертифицированного партнёра платформы в один клик',
  partnerReview: 'Проверка партнёра',
  partnerReviewed: 'Партнёр проверен',
  fillRejectReason: 'Укажите причину отказа',
  auditRejected: 'Проверка отклонена',
  changeServicePersonnel: 'Смена обслуживающего персонала',
  userName: 'Имя пользователя',
  batchChangeSales: 'Массовое изменение результатов продаж',
  positionTypeNotSelected: 'Тип должности не выбран.',
  multipleSameBusinessPosition: 'Обнаружены дублирующиеся записи должностей.',
  defaultValueNotEmpty: 'Значение по умолчанию не может быть пустым!',
  setInitialPassword: 'Установка начального пароля',
  openB2BAccount: 'Активация B2B-аккаунта',
  openB2BSettings: 'Настройка B2B',
  selectBookingAgent: 'Пожалуйста, выберите соответствующего агента по бронированию!',
  batchSelectBookingAgent: 'Пожалуйста, выберите соответствующих агентов по бронированию партией!',
  modificationOfBookingAgents: 'Массовое изменение агентов по бронированию',
  resetPassword: 'Сброс пароля',
  b2bUsers: 'B2B-пользователь',
  selectNotOpenedB2BAccount: 'Выберите контакт без активированного B2B-аккаунта.',
  emailAddressIsIllegal: 'Некорректный email-адрес!',
  selectAnApprovedPartner: 'Выберите проверенного партнёра',
  inputAPassword: 'Введите пароль!',
  accountOpenedSuccessfully: 'Аккаунт успешно активирован!',
  selectAContact: 'Выберите контакт',
  oneContactPasswordCanResetATime: 'Можно сбросить пароль только для одного контакта за раз',
  notOpenedB2BAccount: 'У этого контакта нет активированного B2B-аккаунта',
  confirmToReset: 'Подтвердите сброс',
  yourLoginPassword: 'пароля для входа?',
  openResetPasswordLink: 'Сброс выполнен. Откройте ссылку для сброса пароля в письме.',
  batchModifyServicePersonnel: 'Массовое изменение обслуживающего персонала',
  exportModificationResults: 'Экспорт результатов изменений',
  partnerAbbreviation: 'Сокращённое название партнёра',
  chineseNameOfPartner: 'Китайское название партнёра',
  servicePersonal: 'Обслуживающий персонал',
  isItSuccessful: 'Успешно ли',
  enterUserInformation: 'Введите данные пользователя',
  selectAUserToModify: 'Выберите пользователя для изменения',
  modifyInvoicingHeader: 'Изменение платёжных реквизитов',
  batchModifyInvoicingHeader: 'Массовое изменение платёжных реквизитов',
  enterBillingHeaderInformation: 'Введите платёжные реквизиты',
  batchChangeSalesperson: 'Массовое изменение продавца',
  modifySalesperson: 'Изменить продавца',
  batchModifySalesperson: 'Массовое редактирование продавцов',
  salesman: 'Торговый персонал',
  selectRecordToExport: 'Пожалуйста, выберите записи для экспорта!',
  mergedPartners: 'Объединенный партнер',
  notPermissionEditOverseasAgent: 'У вас нет прав на редактирование зарубежных агентов!',
  notPermissionEditCarrier: 'У вас нет прав на редактирование перевозчика!',
  companyIsSettlementAgentFollowingPartners: 'Эта компания уже является расчетным агентом для следующих партнеров',
  confirmDisassociateAndSaveModification: 'Подтверждаете отмену связи и сохранение изменений?',
  affiliatedBranch: 'Филиал компании',
  contractAffiliatedBranch: 'Филиал, к которому относится контракт',
  alreadyAPartner: 'Уже является партнером?',
  selectAPartner: 'Пожалуйста, выберите партнера!',
  applicationSentSuccessfully: 'Заявка успешно отправлена!',
  addPlatformCertificationPartners: 'Добавьте сертифицированных партнеров платформы для взаимодействия с "Woxing Home" и совместного создания логистической экосистемы.',
  tariffLevelAuthorization: 'Авторизация тарифного уровня',
  fullContainerFreightRate: 'FCL тариф',
  lclFreightRate: 'LCL тариф',
  airFreightRate: 'Авиатариф',
  fbaRate: 'FBA предложение',
  mergePartners: 'Объединение партнеров',
  updateSupplierData: 'Обновление данных клиентов',
  maintainInformation: 'Массовое обслуживание кредитного контроля',
  batchBlacklistSetting: 'Массовая настройка черного списка',
  maintainDefaultCreditInfo: 'Кредитный контроль по умолчанию',
  freightFateLevelIsAuthorized: 'Авторизация тарифного уровня для групп клиентов, а не отдельных лиц',
  servicePersonnelSettingNotEnabled: 'Настройки обслуживающего персонала для партнера не активированы',
  deletedWithAdministratorPermission: 'Удаление возможно только с правами администратора!',
  partnerNotSelected: 'Партнер не выбран.',
  partnerBeenUsedByBusiness: 'Партнер уже используется в бизнесе.',
  mergedPartnerBeenAssociatedWithCRM: 'Объединенный партнер уже связан с CRM',
  mergedPartnerBeenAssociatedWithCRM1: 'Объединенный партнер уже связан с CRM. {0}? После отмены связи партнера можно просмотреть в меню "Корзина клиентов".',
  mergedPartnerBeenAssociatedWithCRM2: 'Принудительное прекращение связи',
  removeAssociationWithPartner: 'Перейдите в [Продажи - Клиенты группы]/[Продажи - Общий пул клиентов], чтобы удалить связь с партнером.',
  partnersWithCustomerAttributeCanBeSelected: 'Можно выбрать только партнеров с атрибутом "Клиент"',
  partnersWithOverseaAgentAttributeCanBeSelected: 'Могут быть выбраны только партнёры с атрибутом наличия зарубежного агента.',
  authorizationSucceeded: 'Авторизация успешна',
  groupCompaniesCannotBeMerged: 'Нельзя объединять холдинговые компании!',
  chooseADifferentPartner: 'Пожалуйста, выберите разных партнеров!',
  noAuthorityToAuditCustomerRolePartners: 'У вас нет прав на проверку партнеров с ролью клиента в выбранных данных!!!',
  noAuthorityToAuditSupplierRolePartners: 'У вас нет прав на проверку партнеров с ролью поставщика в выбранных данных!!!',
  vouchersBeenGeneratedContinue: 'Документ уже создан. Продолжить объединение?',
  mergeSuccessful: 'Объединение успешно',
  uploadXLSFormatFile: 'Пожалуйста, загрузите файл в формате xls/xlsx!',
  updateSucceeded: 'Обновление успешно!',
  failedUpdateSupplierData: 'Не удалось обновить данные клиентов!',
  industrialAndCommercialInformationQuery: 'Поиск регистрационной информации',
  fleetCode: 'Код автопарка',
  platformSupplier: 'Поставщик платформы',
  ouJian: 'Oujian',
  supplierPrincipal: 'Ответственный за поставщика',
  crossTenantEntrustedBookingGeneralProtocol: 'Универсальное соглашение о бронировании грузов между Tenant на платформе CARGOWARE',
  traders: 'Трейдер',
  shortNameCannotBeEmpty: 'Сокращенное название не может быть пустым',
  oneBusinessTypeForCustomer: 'Выберите хотя бы один тип бизнеса клиента',
  customerAddressNotEmpty: 'Адрес клиента не может быть пустым',
  partnerRoleMustBeSelected: 'Необходимо выбрать роль партнера',
  customerBusinessTypeMustBeSelected: 'Тип бизнеса клиента обязателен к выбору',
  usedByVoucherCannotModified: 'Используется в документах, изменение невозможно',
  usedByVoucherAreYouSureModified: 'Для этого партнера уже созданы документы. Вы уверены, что хотите внести изменения?',
  duplicatePartnerCodeAlreadyExists: 'Обнаружен повторяющийся код партнера. Проверьте код партнера!',
  partnerSameNameAlreadyExists: 'Партнер с таким названием уже существует. Проверьте название на китайском или английском.',
  online: 'Онлайн',
  paper: 'Бумажный',
  carrierNotSelected: 'Перевозчик не выбран.',
  carrierAlreadyExists: 'Перевозчик уже существует.',
  bookingMethodNotSelected: 'Способ бронирования не выбран.',
  shortMessage: 'SMS',
  alreadyDefaultContact: 'Контакт по умолчанию уже существует. При сохранении текущий контакт станет значением по умолчанию',
  notSaveTwoDefaultContact: 'Невозможно сохранить два контакта по умолчанию!',
  contactNameAndPhoneNumberCannotBlank: 'Имя контакта и телефон не могут быть пустыми!',
  contactNameCannotBlank: 'Имя контакта не может быть пустым!',
  emailBlankOrFormatError: 'Email пуст или имеет неверный формат!',
  mobileBlankOrFormatError: 'Номер телефона пуст или имеет неверный формат!',
  sameAirlineInvalidMsg: 'Для {0} с маршрутом 【{1}】 уже существует 【{2}】. Пожалуйста, не добавляйте повторно!',
  mailMode: 'Получение по email',
  phoneMode: 'Получение по SMS',
  syncContact: 'Синхронизировать данные с контактами партнеров',
  currentJob: 'Текущий бизнес',
  mobilePhoneNumberValidNumber: 'Номер телефона должен содержать только цифры',
  emailFormatError: 'Неверный формат email',
  emailLengthCannotExceed128Characters: 'Длина email не должна превышать 128 символов',
  phoneNumberLengthCannotExceed32Characters: 'Длина номера телефона не должна превышать 32 символа',
  phoneNumberCannotLongerThan32Characters: 'Длина телефонного номера не должна превышать 32 символа',
  expenseFinancialDate: 'Финансовая дата расходов',
  dailySettlement: 'Ежедневный расчет',
  adjustContractInformationInBasicData: 'Ваша компания активировала меню управления контрактами. Для корректировки информации о кредитном контроле действующих контрактов перейдите в "Базовые данные - Управление контрактами"!',
  masterAgent: 'Главный агент',
  secondaryAgent: 'Вторичный агент',
  billAddressCannotEmpty: 'Адрес для счетов не может быть пустым!',
  nmsCannotEmpty: 'Сетевой администратор не может быть пустым!',
  firstPlease: 'Пожалуйста, сначала',
  selectImportFile: 'Выберите файл для импорта:',
  fileSizeCannotExceed20m: 'Размер файла не должен превышать 20 МБ',
  startImport: 'Начать импорт',
  emailAddress: 'Email адрес',
  specificContactEmailAddress: 'Email адрес конкретного контакта',
  userCannotEmpty: 'Пользователь не может быть пустым!',
  destinationOperationAgentNotMaintained: 'Агент по обработке в порту назначения не настроен.',
  completeInputItems: 'Пожалуйста, заполните все поля',
  disassociateAndSaveModifications: 'Вы уверены, что хотите отменить связь и сохранить изменения?',
  alreadyDefaultBankInformation: 'Уже есть банковские реквизиты по умолчанию, сохранение установит текущие реквизиты как значения по умолчанию',
  ordinary: 'Обычный',
  supervise: 'Контроль',
  warehousingRequirements: 'Требования к размещению на складе',
  alreadyDefaultWarehouse: 'Уже есть склад по умолчанию, сохранение установит текущий склад как склад по умолчанию',
  operateInMasterDataContractManagement: 'Вашей компании предоставлены права доступа к меню "Управление договорами", выполняйте операции в разделе "Базовые данные - Управление договорами"!',
  contract: 'Договор',
  effectiveAndExpirationDateCannotBlank: 'Дата вступления в силу и дата окончания действия не могут быть пустыми',
  fileDeletedSuccessfully: 'Файл успешно удален!',
  viewContactInformation: 'Просмотреть контактную информацию',
  lineAlreadyExistsAndCannotAddedRepeatedly: 'Данный маршрут уже существует, повторное добавление невозможно',
  vendorCannotEmpty: 'Поле "Поставщик" не может быть пустым!',
  confirmDeleteSupplyChainLine: 'Вы уверены, что хотите удалить эту цепочку поставок?',
  deleteSupplyChain: 'Удалить цепочку поставок',
  emailAddress2: 'Адрес электронной почты',
  setDefaultAutoSendMailbox: 'Установить как email по умолчанию для автоматической отправки',
  alreadyDefaultInvoicingHeader: 'Уже есть реквизиты для выставления счетов по умолчанию, сохранение установит текущие реквизиты как значения по умолчанию',
  branchCannotBlank: 'Филиал не может быть пустым.',
  cannotRepeat: 'Нельзя дублировать.',
  bookingAgentNotSelected: 'Агент по бронированию не выбран.',
  bookingAgentAlreadyExists: 'Агент по бронированию уже существует.',
  defaultMarkupRange: 'Наценка по умолчанию',
  rateClass: 'Класс тарифа',
  batchSaveSucceeded: 'Массовое сохранение выполнено успешно',
  priceAdjustmentRecordUsedAndCannotDeleted: 'Запись об изменении цены уже использовалась, удаление невозможно.',
  deleteSucceeded: 'Успешно удалено!',
  selectAppointmentNumberToEdit: 'Пожалуйста, выберите номер соглашения для редактирования!',
  shipSecretaryAppointmentNumberCannotEmpty: 'Номер соглашения судоходной компании не может быть пустым!',
  innerContractNoCannotEmpty: 'Внутренний номер соглашения не может быть пустым!',
  effectiveDateCannotBlank: 'Дата вступления в силу не может быть пустой!',
  expirationDateCannotBlank: 'Дата окончания действия не может быть пустой!',
  expirationDateMustGreaterEqualEffectiveDate: 'Дата окончания действия должна быть больше или равна дате вступления в силу!',
  defaultPriceIncreaseRangeCannotBlank: 'Наценка по умолчанию не может быть пустой!',
  selectRouteCorrespondingToDestinationPort: 'Пожалуйста, выберите маршрут, соответствующий порту назначения!',
  oneRecordWithoutRouteAndDestination: 'Может быть только одна запись без указания маршрута и порта назначения!',
  sameRoute: 'Одинаковый маршрут',
  oneRecordCanGeneratedPleaseModify: 'Разрешено создавать только одну запись, пожалуйста, измените!',
  sameRouteAndDestination: 'Одинаковый маршрут и порт назначения',
  samePol: 'Одинаковый порт отправления',
  associatedRoute: 'Связанный маршрут',
  isParentCompany: 'Является ли материнской компанией',
  isFba: 'Является ли FBA',
  subsidiaryInformation: 'Информация о дочерней компании',
  deleteSubsidiaryTips: 'Пожалуйста, отметьте дочерние компании, которые хотите удалить!',
  deleteSubsidiaryConfirm: 'После удаления связь между материнской и дочерней компанией будет разорвана, продолжить?',
  changeParentCompany: 'Уже есть связанные дочерние компании, сначала разорвите связь с ними, а затем выполняйте операцию!',
  officeChangeForSubsidiaryCompany: 'Уже есть связанные дочерние компании, после изменений дочерняя компания при редактировании материнской может не найти этого партнера, продолжить?',
  quota: 'Лимит',
  monthlySpecifiedDate: 'Указанная дата каждого месяца',
  weeklySettlement: 'Расчет по неделям',
  semilunarKnot: 'Полумесячный расчёт',
  settlementDay: 'Ежедневный расчёт',
  statementDate: 'Дата счёта',
  customerSupplierType: 'Тип контрагента',
  CustomerMailbox: 'Электронная почта клиента',
  WhetherToSendMailAutomatically: 'Автоматическая отправка писем',
  DefaultMailSendingObject: 'Получатель письма по умолчанию',
  DefaultMailSendingObjectTip: 'Если адрес получателя пуст, письмо отправляется создателю счёта',
  BulkUpdateSurcharge: 'Массовое обновление надбавок',
  autoEmailSettings: 'Настройки автоматической отправки писем',
  taxControlPlatformSending: 'Отправка через налоговую платформу',
  systemAutomaticSending: 'Автоматическая отправка системой',
  systemAutomaticSendingObject: 'Получатель автоматической отправки',
  taxControlPlatformSendingObject: 'Получатель отправки налоговой платформы',
  partnerInvoiceReminder: 'Налоговая платформа и система могут отправлять письма на указанные адреса. Если адрес получателя пуст, письмо отправляется создателю счёта.',
  interestFreeCompany: 'Компания с беспроцентным периодом',
  uniformRenewalSurcharge: 'Единое обновление надбавок',
  lookSurcharge: 'Просмотр надбавок',
  batchReplaceAfterSave: 'Примечание: после сохранения все предыдущие надбавки будут заменены для всех маршрутов по текущему тарифу.',
  validityPeriodRepeatedAndCannotCopy: 'Срок действия дублируется, копирование невозможно',
  sameRoutePodPol: 'Одинаковый маршрут, порт отправления и назначения',
  sameRoutePol: 'Одинаковый маршрут и порт отправления',
  agreementContent: 'Сторона А: Заказчик по заказу через Tenant (далее именуемый Сторона А)\n' +
    'Сторона Б: получатель заказа через Tenant (далее именуемый Стороной Б)\n' +
    '\n' +
    'Стороны А и Б, руководствуясь целями « повышения эффективности, сокращения звеньев, содействия развитию, четкой ответственности и нормативного поведения», в соответствии с положениями соответствующих законов и правил государства и города Шанхая, в отношении использования стороной Б электронного бронирования через платформу CARGOWARE, достигли следующего соглашения в соответствии с принципом « равенства, взаимной выгоды и консенсуса»:\n' +
    '\n' +
    'Глава I Общие положения\n' +
    'Настоящее Соглашение представляет собой официальное общее соглашение между Стороной А и Стороной В в отношении морских экспортных операций путем электронного бронирования по заказу через платформу CARGOWARE; Начиная с момента, когда стороны договорились о согласии с настоящим Соглашением на платформе CARGOWARE через доверенность Tenant, платформа CARGOWARE считается, что пользователь платформы согласился с обязанностями и обязательствами по настоящему Соглашению;\n' +
    '2. Сторона А учреждает в соответствии с законом независимое юридическое лицо, имеющее действующую лицензию на осуществление предпринимательской деятельности и законно осуществляющее операции агентов по международной перевозке грузов в рамках деятельности, указанной в лицензии на осуществление предпринимательской деятельности;\n' +
    '3. Сторона Б учреждает в соответствии с законом независимое юридическое лицо, имеющее действующую лицензию на осуществление предпринимательской деятельности и законно осуществляющее операции агентов по международной перевозке грузов в рамках деятельности, указанной в лицензии на осуществление предпринимательской деятельности.\n' +
    'Стороны А и В легально получают идентификатор корпоративного пользователя Платформы и Key (электронную подпись данных) после регистрации и аудита Платформы CARGOWARE. Любые действия, совершаемые обеими сторонами через платформу CARGOWARE с помощью электронных подписей данных, рассматриваются обеими сторонами как подлинное выражение их намерения, подтверждающее и готовое взять на себя всю ответственность и риски, связанные с этим;\n' +
    '5. Сторона А соглашается обратиться к Стороне Б с просьбой о бронировании в форме электронного бронирования, заказанного через платформу Tenant, взамен бумажного коносамента и взамен штампа бронирования в форме Tenant ID и Key.\n' +
    'Сторона Б заменяет бумажные квитанции на бронирование кают электронным авизо через доверенность Tenant и подтверждает бронирование в виде идентификаторов Tenant ID и Key и принимает заказ от Стороны А; Сторона Б в соответствии с условиями, предусмотренными в соответствующем бизнес - соглашении Сторон, от имени А осуществляет распределение и погрузку груза на экспорт перевозчику или агенту перевозчика; Вход на склад, упаковка, погрузка и ряд других операций экспедитора;\n' +
    'Механизм и способ реализации электронного процесса бронирования, заказанного обеими сторонами по всему Tenant, заранее разработаны облачной платформой данных, и обе стороны заполняют идентификатор Tenant друг друга в этом функциональном элементе;\n' +
    'Обе стороны несут ответственность за предотвращение незаконного проникновения или незаконной передачи, обеспечение того, чтобы операторы, которые они отправляют и получают, имели законное разрешение на эффективную защиту бизнес - записей и данных от незаконного вторжения, изменения или уничтожения;\n' +
    '9. После получения от Стороны А электронной заявки на бронирование по заказу компании & quot; ТрансТенант & quot; Сторона Б должна своевременно направить через Платформу квитанцию. Сторона А должна постоянно следить за состоянием своей заявки на электронный заказ, если она не получает от другой стороны информацию об обработке, Сторона А обязана как можно скорее связаться с Стороной Б и выяснить причину;\n' +
    'Если стороны А и В не получили подтверждения в течение согласованного разумного срока, они должны принять соответствующие меры, в противном случае стороны имеют право предполагать, что первоначальная передача была получена, и платформа CARGOWARE не несет никакой ответственности за своевременность и действительность принятия обеими сторонами;\n' +
    '11. Данные о бронировании и квитанции через систему Tenant, соответствующие требованиям эксплуатационных спецификаций Платформы, имеют такую же юридическую силу, как и бумажные документы; Сторона А имеет право на возмещение фрахта за груз, отгруженный Стороной Б.\n' +
    'Глава II. Расходы и расчеты\n' +
    'Деловые поручения, связанные с электронным бронированием, которые стороны А и В поручают через Транстенант, выполняются в соответствии с конкретными условиями подписанного сторонами соглашения о экспедиторском обслуживании и соответствующего соглашения о расчете расходов.\n' +
    'Глава III. Права и обязанности сторон\n' +
    'Если неправильное хранение электронных подписей данных, предоставленных платформой CARGOWARE, или ненадлежащая авторизация привели к использованию или незаконному использованию данных другими лицами по причинам Стороны А, Сторона А несет ответственность за соответствующие последствия;\n' +
    '2. Сообщение данных, направленное А Стороне В, или информация, вводимая в режиме онлайн в электронную систему Стороны А, включает, но не ограничивается, точный срок предварительного отгрузки или рейс воздушного судна, наименование перевозчика, номер коносамента, номер соглашения, порт назначения, порт разгрузки, спецификацию груза (наименование, количество мест, вес брутто, объем, описание свойств груза, размеры специального груза и т.д.\n' +
    '3. Для специальных грузов, отправленных по заказу стороны А, таких как опасные грузы, рефрижераторные грузы, сверхгабаритные грузы, грузы, требующие досмотра в ящиках или требующие специальных контейнеров для перевозки, а также для других специальных грузов, Сторона А должна представить письменное подтверждение в бумажной форме, чтобы принять свой заказ, например, чертежи сверхгабаритных грузов и свидетельство о предварительном охлаждении рефрижераторных контейнеров. Для перевозки опасных грузов требуется также бумажная декларация об опасных грузах и свидетельство об упаковке опасных грузов а также другие документы требуемые перевозчиком. За некоторые товары, требующие предварительной оплаты, а затем бронирования, сторона Б должна быть своевременно оплачена, прежде чем принимать бронирование;\n' +
    'Подлинная информация стороны А о грузе должна быть указана в электронном бронировании, если ложное заявление стороны А наносит ущерб интересам стороны Б или третьего лица, сторона А несет соответствующую ответственность за ущерб;\n' +
    '5. Сторона А, которая должна внести изменения в информацию о заказе на бронирование, должна уведомить Сторону Б в день погрузки груза в контейнер или в склад (хранилище); Сторона А должна обратиться к Стороне Б с просьбой об изменении в письменной форме или в другой форме, согласованной Сторонами;\n' +
    'Сторона А обязана оплатить фрахт, надбавку и другие расходы за груз, вверенный Стороне Б посредством электронного бронирования;\n' +
    'Если заказанная Сторона А требует возврата таможенной накладной, она должна своевременно представить ее в письменной форме или в другой форме, согласованной Сторонами, в противном случае Сторона Б несет всю ответственность и расходы, возникающие в связи с этим.\n' +
    '8. Сторона Б, получившая электронный заказ по Транстенанту от Стороны А, должна в разумный срок подтвердить принятие или отклонение заказа стороной Б в форме электронных данных;\n' +
    '9. В связи с аномальными сбоями в работе их собственных сетей, общественных сетей или платформ CARGOWARE стороны должны использовать традиционные бумажные методы бронирования для бронирования и передачи информации.\n' +
    'Глава IV. Подтверждение электронного бронирования\n' +
    '1. Сторона Б должна своевременно обработать электронное сообщение о бронировании, полученное Стороной А, в течение разумного периода времени, должна направить в соответствии с требованиями Платформы квитанцию, подтверждающую принятие заказа или отказ, в отказе должны быть указаны причины отказа;\n' +
    '2. Сторона А может считаться принявшей поручение Стороны А только после того, как Сторона Б возвратит электронное авизо о бронировании, подтверждающее получение заказа;\n' +
    '3. если Сторона А до подтверждения Стороной Б осуществляет ряд действий, которые могут быть осуществлены только после принятия Стороной Б заказа на фрахт, то это деяние считается нарушением, в связи с чем все юридические обязательства и риски несет Сторона А;\n' +
    '4. Сторона Б принимает от имени перевозчика поручения стороны А по бронированию и осуществляет соответствующие экспортные перевозки в соответствии с подтвержденным содержанием и требованиями бронирования.\n' +
    'ГЛАВА V. ИСПОЛНЕНИЕ СОГЛАШЕНИЙ\n' +
    'Стороны А и В должны строго соблюдать соответствующие положения настоящего Соглашения и его положений.\n' +
    '2. Ни одна из сторон соглашения не может уступать интересы по настоящему соглашению какому - либо лицу или организации, не связанным с другими сторонами.\n' +
    '3. Любая сторона соглашения, выполняющая свои обязательства по настоящему Соглашению, в силу форс - мажорных обстоятельств не может или не может своевременно выполнить относящиеся к соглашению вопросы, незамедлительно уведомляет другую сторону и прилагает все усилия для использования других средств. Стороны соглашения, в течение которого происходит задержка, упущение или ошибка в сообщении данных, не несут ответственности за неблагоприятные последствия, вызванные этим временем.\n' +
    '4. Если одна из сторон соглашения обнаруживает нарушение безопасности, незаконное использование или незаконные действия, она незамедлительно уведомляет другую сторону и другие заинтересованные стороны и проводит расследование и сообщает о своих выводах другой стороне и другим заинтересованным сторонам. В течение этого периода электронные данные должны временно приостанавливаться до тех пор, пока обстановка в плане безопасности не нормализуется.\n' +
    '5. Если стороны А и В подписывают « Соглашение об экспедиторском обслуживании», то настоящее Соглашение прилагается к этому Соглашению, и оно не выполняется в полной мере в соответствии с соответствующими положениями Соглашения об экспедиторском обслуживании грузов.\n' +
    'Глава VI.\n' +
    'Ни одна из сторон настоящего Соглашения не может изменять и расторгать Соглашение без разрешения. В тех случаях, когда имеются исключительные причины, по которым исполнение не может продолжаться или может быть изменено, изменение или прекращение соглашения должно быть произведено с согласия другой стороны и в течение срока, указанного в соглашении. В случае предъявления требования вне срока, предусмотренного соглашением, фактический ущерб, причиненный другой стороной, должен быть покрыт.\n' +
    'В случае прекращения действия настоящего Соглашения по взаимному согласию Стороны удаляют данные о согласии и удаляют соответствующую информацию о конфигурации на платформе CARGOWARE через пункт доверенности Tenant.\n' +
    'ГЛАВА VII.\n' +
    'Стороны, нарушившие соглашение, должны возместить друг другу фактический ущерб, причиненный этим действием.\n' +
    'ГЛАВА VIII. ДРУГИЕ\n' +
    'Любой спор, возникающий в связи с настоящим Соглашением, должен быть урегулирован сторонами путем переговоров на основе принципа взаимности и взаимной выгоды, а в случае его отсутствия - путем подачи иска в местный морской суд по месту регистрации и эксплуатации сторон.',
  SuccessSyncCloudAndStarrySky: 'Синхронизация с Cloud Star успешна',
  FailSyncCloudAndStarrySky: 'Ошибка синхронизации с Cloud Star, {0}',
  HMSyncYongYouSuccess: 'Синхронизация данных клиента с Yonyou успешна. Сообщение "{0}"',
  HMSyncYongYouFail: 'Ошибка синхронизации данных клиента с Yonyou, {0}',
  HMSyncYongYouSuccess2: 'Синхронизация данных поставщика с Yonyou успешна. Сообщение "{0}"',
  HMSyncYongYouFail2: 'Ошибка синхронизации данных поставщика с Yonyou, {0}',
  bankEnglishName: 'Название банка (на английском)',
  bankAddress: 'Адрес банка',
  bankEnglishAddress: 'Адрес банка (на английском)',
  EidtBranchNotSameTip: 'Перед редактированием переключите филиал в правом верхнем углу на компанию партнёра.',
  BranchNoPartnerPermission: 'Текущий филиал не имеет прав на редактирование партнёра!',
  DeleteBranchNotSameTip: 'Перед удалением переключите филиал в правом верхнем углу на компанию партнёра.',
  operateBranchNotSameTip: 'Нет прав доступа. Переключите филиал на компанию партнёра.',
  BranchNoDeletePartnerPermission: 'Текущий филиал не имеет прав на удаление партнёра!',
  MergeBranchNotSameTip: 'Перед объединением переключите филиал в правом верхнем углу на компанию партнёра.',
  BranchNoMergePartnerPermission: 'Текущий филиал не имеет прав на объединение партнёров!',
  UnifiedSign: 'Единая подпись',
  IfRisk: 'Рискованный контрагент',
  customerCode: 'Код клиента',
  supplierCode: 'Код поставщика',
  customerCodeNotSupportChinese: 'В коде клиента нельзя использовать китайские символы',
  supplierCodeNotSupportChinese: 'В коде поставщика нельзя использовать китайские символы',
  customersAndSuppliersMustChooseOne: 'Необходимо выбрать клиента или поставщика',
  CustomerCodeNotEmpty: 'Код клиента не может быть пустым',
  SupplierCodeNotEmpty: 'Код поставщика не может быть пустым',
  CustomerCodeCheck: 'Неверный формат кода клиента нового поколения. Введите 13 цифр.',
  SupplierCodeCheck: 'Неверный формат кода поставщика нового поколения. Введите одну букву (A/B/C/D) и 7 цифр.',
  CcGroup: 'Копия группе',
  CcAddress: 'Копия адресату',
  ccAgentOverseaOp: 'К аг.и заруб.КС',
  UseEmailGroup: 'ГР Рассылка',
  PartnersApprovedTips: 'Выбранные данные содержат проверенные неизменяемые элементы. Снимите выделение и продолжите',
  isInternalCorrespondent: 'Является ли внутренней связанной компанией',
  internalCorrespondent: 'Внутренняя связанная компания',
  batchAddServer: 'Массовое добавление обслуживающего персонала',
  batchAddServerNoSelected: 'Выберите партнера для добавления обслуживающего персонала',
  batchAddServerConfigError: 'Выбранный партнер не поддерживает обслуживающий персонал',
  addServicePersonnel: 'Добавить обслуживающий персонал',
  BookingAgentLevel: 'Уровень бронирующего агента',
  bookingAgentLevelNotSelected: 'Уровень бронирующего агента не выбран',
  Underestimation: 'Расчет задолженности',
  IfAdvancePayment: 'Предоплата',
  CreditRemarks: 'Дополнительные условия кредита',
  DefaultSettlementForInsurance: 'Объект расчетов по страховке по умолчанию',
  DriverInformation: 'Информация о водителе',
  DriverName: 'Имя водителя',
  DriverPhoneNumber: 'Мобильный номер водителя',
  PlateNumber: 'Номерной знак',
  IdentityCard: 'Номер удостоверения личности',
  DriverNameRequired: 'Имя водителя обязательно',
  CreditUnit: 'Единица лимита',
  creditDateUnit: 'Единица расчетного периода',
  b2bDisplay: 'Отображать в B2B'
}
